import { createSlice } from "@reduxjs/toolkit";
import { getRevenueChartsData, getDashboardData } from './thunk';

export const initialState = {
  revenueData: [],
  documentData: [],
  documentCategory: [],
  categoryData: [],
  documentStatus: [],
  statusData: [],
  lawData: [],
  chatData: [],
  documentParaLegal: [],
  paraLegalData: [],
  loading: false,
  error: {}
};

const DashboardEcommerceSlice = createSlice({
  name: 'DashboardEcommerce',
  initialState,
  reducer: {},
  extraReducers: (builder) => {
    builder.addCase(getRevenueChartsData.fulfilled, (state, action) => {
      state.revenueData = action.payload;
    });
    builder.addCase(getRevenueChartsData.rejected, (state, action) => {
      state.error = action.error.message;
    });

    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.documentData = action.payload.Document || [];
      state.documentCategory = action.payload.DocumentCategory || [];
      state.categoryData = action.payload.CategoryData || [];
      state.documentStatus = action.payload.DocumentStatus || [];
      state.statusData = action.payload.StatusData || [];
      state.documentParaLegal = action.payload.DocumentParaLegal || [];
      state.paraLegalData = action.payload.ParaLegalData || [];
      state.lawData = action.payload.Law || [];
      state.chatData = action.payload.Chat || [];
      state.loading = false;
    });
    builder.addCase(getDashboardData.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });
  }
});

export default DashboardEcommerceSlice.reducer;